import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

const sections = [
  { id: "review", key: "review", icon: "ri-search-eye-line", color: "bg-secondary-100 text-secondary-900" },
  { id: "shipping", key: "shipping", icon: "ri-plane-line", color: "bg-primary-100 text-primary-700" },
  { id: "safety", key: "safety", icon: "ri-shield-star-line", color: "bg-accent-100 text-accent-900" },
];

export default function InfoCards() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {sections.map((s) => (
            <div
              key={s.id}
              id={s.id}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-7"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${s.color}`}>
                <i className={`text-xl ${s.icon}`} aria-hidden="true"></i>
              </span>
              <h2 className="mt-5 font-heading text-xl text-foreground-950">{t(`${s.key}.title`)}</h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{t(`${s.key}.text`)}</p>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-primary-700 hover:underline"
              >
                {t(`${s.key}.cta`)}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
                </span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}